export const CONTACT_MODAL_ACTIONS = Object.freeze({
  ADD: 'ADD',
  MANAGE: 'MANAGE'
});
export const CONTACT_MODAL_HEADING_LABEL = Object.freeze({
  ADD: 'Add new contact',
  MANAGE: 'Manage contact'
});
export const CONTACT_MODAL_BUTTON_TEXT = Object.freeze({
  ADD: 'Add contact',
  MANAGE: 'Save contact'
});